/* global axios */
import { aichatRequest } from 'helpers/request';
import ApiClient from './ApiClient';
import { getBaseUrl } from 'shared/helpers/env';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
    inbox,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        inbox_ids: inbox?.join(','),
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours, inbox) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        inbox_ids: inbox?.join(','),
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getConversationMetric(type = 'account', page = 1) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours, inbox }) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until, business_hours: businessHours, inbox_ids: inbox?.join(',') },
    });
  }

  getAgentDailyReports({ from: since, to: until, businessHours, inbox }) {
    return axios.get(`${this.url}/daily`, {
      params: { since, until, business_hours: businessHours, timezone_offset: getTimeOffset(), inbox_ids: inbox?.join(',') },
    });
  }

  getConversationTrafficCSV() {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset() },
    });
  }

  getLabelReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/labels`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getInboxReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getTeamReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/teams`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getBotMetrics({ from, to } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: { since: from, until: to },
    });
  }

  getBotSummary({ from, to, groupBy, businessHours } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        type: 'account',
        group_by: groupBy,
        business_hours: businessHours,
      },
    });
  }

  getAgentOnlineHeatmap(params) {
    return axios.get(`${getBaseUrl('aichat')}/n/api/buyer/cs/aichat/agents/heatmap`, {
      params: {
        ...params,
        teamIds: params.teamIds?.join(',') || '',
        agentIds: params.agentIds?.join(',') || '',
      },
    });
  }

  apiGetAgentConversationMetric(params) {
    return aichatRequest.get('/n/api/buyer/cs/aichat/reports/agent', {
      params: {
        pageNo: params.pageNo ?? 1,
        pageSize: params.pageSize ?? 999,
        accountId: params.accountId,
        teamIds: params.teamIds?.join(',') || '',
        agentIds: params.agentIds?.join(',') || '',
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
  }

  apiGetDepartmentConversationMetric(params) {
    return aichatRequest.get('/n/api/buyer/cs/aichat/reports/team/overview', {
      params: {
        pageNo: params.pageNo ?? 1,
        pageSize: params.pageSize ?? 25,
        accountId: params.accountId,
        teamIds: params.teamIds?.join(',') || '',
      },
    });
  }

  apiGetInboxConversationMetric(params) {
    return aichatRequest.get('/n/api/buyer/cs/aichat/reports/inbox', {
      params: {
        pageNo: params.pageNo ?? 1,
        pageSize: params.pageSize ?? 25,
        accountId: params.accountId,
      },
    });
  }
}

export default new ReportsAPI();
